import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BarChart3, CalendarDays, Sparkles, WalletCards } from "lucide-react";
import VoiceBookingDialog from "@/components/VoiceBookingDialog";

const navItems = [
  { to: "/panel", label: "Randevular", icon: CalendarDays, testId: "bottom-nav-randevular" },
  { to: "/panel/kasa", label: "Kasa", icon: WalletCards, testId: "bottom-nav-kasa" },
  { to: "/panel/raporlar", label: "Rapor", icon: BarChart3, testId: "bottom-nav-raporlar" },
  { to: "/panel/abonelik", label: "Abonelik", icon: Sparkles, testId: "bottom-nav-abonelik" },
];

export default function BusinessBottomNav({ isPro, isLoading }) {
  const location = useLocation();
  const isActive = (to) => (to === "/panel" ? location.pathname === to : location.pathname.startsWith(to));

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 px-4 pb-[max(0.7rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl"
      aria-label="İşletme ana menüsü"
      data-testid="business-bottom-nav"
    >
      <div className="mx-auto grid max-w-md grid-cols-5 items-end">
        {navItems.slice(0, 2).map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              className="flex flex-col items-center gap-1 px-2 py-1 text-xs font-semibold"
              data-testid={item.testId}
            >
              <Icon className={isActive(item.to) ? "h-5 w-5 text-amber-400" : "h-5 w-5 text-slate-500"} />
              <span className={isActive(item.to) ? "text-amber-300" : "text-slate-400"}>{item.label}</span>
            </Link>
          );
        })}
        <div className="flex justify-center">
          <VoiceBookingDialog isPro={isPro} isLoading={isLoading} />
        </div>
        {navItems.slice(2).map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              className="flex flex-col items-center gap-1 px-2 py-1 text-xs font-semibold"
              data-testid={item.testId}
            >
              <Icon className={isActive(item.to) ? "h-5 w-5 text-amber-400" : "h-5 w-5 text-slate-500"} />
              <span className={isActive(item.to) ? "text-amber-300" : "text-slate-400"}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}